import {
  AbridgedVersion,
  AbridgedVersionReprint,
  ConciseEdition,
  ConciseEditionReprint,
  DustiOldRagPoems,
  DustiOldRagPoemsReprint,
  DustiOldRagPoemsReprintSinhala,
  DustiOldRagPoemsSinhala,
  SecondEdition,
  SecondEditionReprint,
  ThirdEditionReprintSinhala,
  ThirdEditionSinhala,
} from "./Descrptions";
import React from "react";
export const BookData = [
  {
    title: "Third Edition",
    description: <SecondEdition />,
    image: require("../assets/images/bookCovers/cover_third_edition.png"),
    file: "./pdfs/e-books/third.pdf",
    fileName:
      "The Anatomy of Awakening Third Edition eBook Ajaan Nico Jotidhammo",
    fileSize: "20.6MB",
  },
  {
    title: "A Taste of Dhamma",
    description: "",
    image: require("../assets/images/bookCovers/tastOfDhamma.png"),
    file: "./pdfs/e-books/A_Taste_of_Dhamma.pdf",
    fileName: "A Taste of Dhamma.pdf",
    fileSize: "6.5MB",
  },
  {
    title: "The Song of a Dusty Old Rag (And Other Poems)",
    description: <DustiOldRagPoems />,
    image: require("../assets/images/bookCovers/Booklet_of_Dhamma_Verses.png"),
    file: "./pdfs/e-books/Booklet_of_Dhamma_Verses.pdf",
    fileName: "Booklet of Dhamma Verses.pdf",
    fileSize: "13.5MB",
  },
  {
    title: "Recollecting Luangta’s Way of Practice",
    description: "",
    image: require("../assets/images/bookCovers/Recollecting.png"),
    file: "./pdfs/e-books/Recollecting_Luangta_s_Way_of_Practice.pdf",
    fileName: "Recollecting Luangta’s Way of Practice.pdf",
    fileSize: "3.9MB",
  },
  {
    title: "A Convergence of Maps",
    description: "",
    image: require("../assets/images/bookCovers/Convergence.png"),
    file: "./pdfs/e-books/A_Convergence_of_Maps.pdf",
    fileName: "A Convergence of Maps.pdf",
    fileSize: "6.5MB",
  },
  {
    title: "Abridged Version",
    description: <AbridgedVersion />,
    image: require("../assets/images/bookCovers/cover_Abridged_Version.png"),
    file: "./pdfs/e-books/abridged.pdf",
    fileName:
      "The Anatomy of Awakening Abridged Version eBook Ajaan Nico Jotidhammo",
    fileSize: "3.3MB",
  },
  {
    title: "Concise Meditation Guide",
    description: <ConciseEdition />,
    image: require("../assets/images/bookCovers/cover_Consise_Version.png"),
    file: "./pdfs/e-books/concise.pdf",
    fileName:
      "The Anatomy of Awakening Concise Meditation Guide eBook Ajaan Nico Jotidhammo.pdf",
    fileSize: "2.1MB",
  },
];

export const BookDataTranslations = [
  {
    title: "Second Edition (Sinhala)",
    description: <ThirdEditionSinhala />,
    image: require("../assets/images/bookCovers/cover_third_edition_sinhala.png"),
    file: "./pdfs/e-books/third-sinhala.pdf",
    fileName:
      "The Anatomy of Awakening Second Edition Sinhala eBook Ajaan Nico Jotidhammo.pdf",
    fileSize: "19MB",
  },
  {
    title: "Booklet of Dhamma Verses (Sinhala)",
    description: <DustiOldRagPoemsSinhala />,
    image: require("../assets/images/bookCovers/Booklet_of_Dhamma_Verses_sinhala.png"),
    file: "./pdfs/e-books/Booklet_Sinhala_ePDF.pdf",
    fileName: "Booklet of Dhamma Verses Sinhala - Ajaan Nico Jotidhammo.pdf",
    fileSize: "11.9MB",
  },
];
export const ReprintBookData = [
  {
    title: "Third Edition",
    description: <SecondEditionReprint />,
    // image: require("../assets/images/bookCovers/cover_Second_Edition.jpg"),
    file: "./pdfs/reprints/third_edition.zip",
    fileName:
      "The Anatomy of Awakening Third Edition_print - Ajaan Nico Jotidhammo",
    fileSize: "24.2MB",
    extension: "zip",
  },
  {
    title: "The Song of a Dusty Old Rag (And Other Poems)",
    description: <DustiOldRagPoemsReprint />,
    // image: require("../assets/images/bookCovers/cover_Consise_Version.jpg"),
    file: "./pdfs/reprints/booklet_of_Dhamma_verses.zip",
    fileName: "Booklet of Dhamma Verses - Ajaan Nico Jotidhammo",
    fileSize: "35.9MB",
    extension: "zip",
  },

  {
    title: "A Convergence of Maps",
    description: <ThirdEditionReprintSinhala />,
    // image: require("../assets/images/bookCovers/cover_Consise_Version.jpg"),
    file: "./pdfs/reprints/a_Convergence_of_Maps.zip",
    fileName: "A Convergence of Maps - Ajaan Nico Jotidhammo",
    fileSize: "11.1MB",
    extension: "zip",
  },
  {
    title: "Abridged Version",
    description: <AbridgedVersionReprint />,
    // image: require("../assets/images/bookCovers/cover_Abridged_Version.jpg"),
    file: "./pdfs/reprints/abridged_version.zip",
    fileName:
      "The Anatomy of Awakening Abridged Version_print - Ajaan Nico Jotidhammo",
    fileSize: "4MB",
    extension: "zip",
  },
  {
    title: "Concise Meditation Guide",
    description: <ConciseEditionReprint />,
    // image: require("../assets/images/bookCovers/cover_Consise_Version.jpg"),
    file: "./pdfs/reprints/concise_version.zip",
    fileName:
      "The Anatomy of Awakening Concise Meditation Guide_print - Ajaan Nico Jotidhammo",
    fileSize: "3MB",
    extension: "zip",
  },
  {
    title: "Second Edition (Sinhala)",
    description: <ThirdEditionReprintSinhala />,
    // image: require("../assets/images/bookCovers/cover_Consise_Version.jpg"),
    file: "./pdfs/reprints/third_edition(sinhala).zip",
    fileName:
      "The Anatomy of Awakening Second Edition_print (Sinhala) - Ajaan Nico Jotidhammo",
    fileSize: "25.5MB",
    extension: "zip",
  },

  {
    title: "The Song of a Dusty Old Rag (And Other Poems) (Sinhala)",
    description: <DustiOldRagPoemsReprintSinhala />,
    // image: require("../assets/images/bookCovers/cover_Consise_Version.jpg"),
    file: "./pdfs/reprints/booklet_of_Dhamma_verses(sinhala).zip",
    fileName: "Booklet of Dhamma Verses (Sinhala) - Ajaan Nico Jotidhammo",
    fileSize: "32.4MB",
    extension: "zip",
  },
];
